export const ROLE_OPTIONS = [
  "admin",
  "trader",
  "viewer",
  "account_manager",
  "sales",
  "risk",
  "researcher",
  "operations",
  "sales_admin",
  "trader_admin",
  "operations_admin",
] as const;

export type Role = (typeof ROLE_OPTIONS)[number];

export const ROLE_IMPLICATIONS: Record<Role, Role[]> = {
  admin: [
    "trader",
    "viewer",
    "account_manager",
    "sales",
    "risk",
    "researcher",
    "operations",
    "sales_admin",
    "trader_admin",
    "operations_admin",
  ],
  trader: ["viewer"],
  viewer: [],
  account_manager: ["viewer"],
  sales: ["viewer"],
  risk: ["viewer"],
  researcher: ["viewer"],
  operations: ["viewer"],
  sales_admin: ["sales", "viewer"],
  trader_admin: ["trader", "viewer"],
  operations_admin: ["operations", "viewer"],
};

export function isRole(value: string): value is Role {
  return (ROLE_OPTIONS as readonly string[]).includes(value);
}
